export default "__VITE_ASSET__8EEDDCbe__"